import * as React from 'react'

import type { CarouselCardViewModel } from '../../view-models/CarouselCardViewModel'
import CtaButton from '../CtaButton/CtaButton'
import Heading from '../Heading/Heading'
import Image from '../Image/Image'
import Paragraph from '../Paragraph/Paragraph'
import styles from './carouselCard-style.css'
import stylesDesktop from '../CarouselDesktop/carouselDesktop-style.css'
import { ButtonTypes } from '@/view-models/ButtonTypes'

type Props = {
  item: CarouselCardViewModel
  width?: number
  isActive?: boolean
  cardIndex?: number
  activeIndex?: number
  className?: string
  useAsHeader?: boolean
}

class CarouselCard extends React.Component<Props> {
  static displayName = 'CarouselCard'
  static defaultProps = {}

  render() {
    const { item, width, cardIndex, className, useAsHeader } = this.props
    const eventMeta = {
      event: 'karrusel',
      eventData: 'link-click',
    }

    return !item ? null : (
      <div className={styles.mainSliderCard}>
        <div className={className}>
          <div>
            {width && width < 992 && item.image ? (
              <div className={stylesDesktop.carouselCard}>
                {item.link ? (
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a
                    aria-hidden="true"
                    tabIndex={-1}
                    href={item.link.href}
                    target={item.link.target}
                    className={stylesDesktop.imgLink}
                  />
                ) : null}
                <Image
                  {...item.image}
                  className={styles.cardImage}
                  width={775}
                  height={500}
                />
              </div>
            ) : (
              <div className={styles.placeholder} />
            )}
            <div className={styles.innerCardText}>
              {item.title && (
                <Heading
                  className={styles.item}
                  level={2}
                  tag={useAsHeader && cardIndex === 0 ? 'h1' : 'h2'}
                >
                  {item.title}
                </Heading>
              )}
              {item.text && (
                <Paragraph className={styles.item} weight={'light'}>
                  {item.text}
                </Paragraph>
              )}
              {item.link && (
                <div className={styles.item}>
                  <CtaButton {...item.link} version={0} eventMeta={eventMeta} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CarouselCard
